const INITIAL_STATE = {
  currentUser: {},
  company: {},
  notifications: [],
};

const store = {
  namespaced: true,
  state: INITIAL_STATE,
  mutations: {
    SET_CURRENT_USER(state, value) {
      state.currentUser = value;
    },

    SET_COMPANY(state, value) {
      state.company = value;
    },

    SET_NOTIFICATION(state, value) {
      state.notifications.push(value);
    },
  },
  actions: {
    notify({ commit }, notification) {
      commit('SET_NOTIFICATION', notification);
    },

    reset({ commit }) {
      commit('SET_CURRENT_USER', {});
      commit('SET_COMPANY', {});
      commit('SET_NOTIFICATION', []);
    },
  },
};

export default store;
